import { createRuntimeServiceAccessKey } from '@dynamic-labs-sdk/client/core';

import { createSignClient } from './createSignClient';

export const getSignClient = createRuntimeServiceAccessKey(
  'walletConnectSignClient',
  (client) => createSignClient(client)
);
